import { render, staticRenderFns } from "./applyFeeDeduction.vue?vue&type=template&id=17b0a570&scoped=true"
import script from "./applyFeeDeduction.vue?vue&type=script&lang=js"
export * from "./applyFeeDeduction.vue?vue&type=script&lang=js"
import style0 from "./applyFeeDeduction.vue?vue&type=style&index=0&id=17b0a570&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17b0a570",
  null
  
)

export default component.exports